import { Directive, inject, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { debounceTime, map } from 'rxjs';
import { FormUtils } from "../form-utils";

@Directive({
  selector: '[iriroForm]',
  standalone: true,
})
export class FormDirective<T> {

  // Inject its own `NgForm` instance
  public readonly ngForm = inject(NgForm, { self: true });
  @Input() public formValue: T | null = null;

  @Output() public readonly formValueChange = this.ngForm.form.valueChanges.pipe(
    debounceTime(0)
  );

  @Output() public readonly dirtyChange = this.formValueChange.pipe(
    map(() => this.ngForm.dirty)
  );

  @Output() public readonly validChange = this.formValueChange.pipe(
    map(() => this.ngForm.valid),
  );

  constructor() {
    this.ngForm.ngSubmit.subscribe(() => {
      FormUtils.markAllAsDirty(this.ngForm.form);
      this.ngForm.form.markAllAsTouched();
    });
  }
}

